import React from 'react';
import { Check } from 'lucide-react';
import './OnboardingProgressBar.css';

const steps = [
    { id: 1, label: 'Project Type' },
    { id: 2, label: 'Location' },
    { id: 3, label: 'Professionals' },
    { id: 4, label: 'Project Plan' }
];

const OnboardingProgressBar = ({ currentStep }) => {
    // Calculate progress width for the green line
    // currentStep is 1-based index of the active step. 
    // If step 1 is active, progress is 0% (at the start).
    // If step 4 is active (final), progress should probably fill up to the last circle.
    // 4 steps means 3 intervals.
    const progressPercentage = Math.min(100, Math.max(0, ((currentStep - 1) / (steps.length - 1)) * 100));

    return (
        <div className="onboarding-progress-bar">
            <div className="progress-fill" style={{ width: `${progressPercentage}%` }}></div>
            {steps.map((step) => {
                const isCompleted = step.id < currentStep;
                const isActive = step.id === currentStep;
                
                let statusClass = '';
                if (isCompleted) statusClass = 'completed';
                else if (isActive) statusClass = 'active';

                return (
                    <div key={step.id} className={`progress-step ${statusClass}`}>
                        <div className="step-circle">
                            {isCompleted ? <Check size={16} /> : step.id}
                        </div>
                        <span className="step-label">{step.label}</span>
                    </div>
                );
            })}
        </div>
    );
};

export default OnboardingProgressBar;
